<template>
	<div class="pm-detail">
		<!-- 顶部导航栏 -->
		<div class="pm-detail-nav flex align-items-center">
			<div class="hd nav-btns">
				<span style="border-right: 1px solid #e7e7e7" role="button" class="btn flex-center" @click="toPm">
					<i class="el-icon-arrow-left text-bold"></i>
				</span>
				<el-dropdown trigger="click" placement="bottom-start" @command="handleCommandChange">
					<span role="button" class="btn flex-center">
						<i class="el-icon-caret-bottom font-2x"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in recentList" :key="item.projectid" :command="item.projectid">{{ item.title }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="bd ml flex align-items-center">
				<span class="pl-sm font-18">{{ project.project_title }}</span>
				<span class="ml" @click="starProject">
					<i v-show="project.star" class="el-icon-star-on text-warning font-lg common-icon"></i>
					<i v-show="!project.star" class="el-icon-star-off font-lg common-icon"></i>
				</span>
				<el-menu :default-active="activeTab" mode="horizontal" text-color="#010101" active-text-color="#07c160" class="ml-lg" @select="switchTab">
					<el-menu-item index="task">
						<template slot="title">
							<div class="flex-center">
								<i role="button" class="iconfont icon-task font-lg mr-sm" />
								<span class="font-md">任务</span>
							</div>
						</template>
					</el-menu-item>
					<el-menu-item index="deliver">
						<template slot="title">
							<div class="flex-center">
								<i role="button" class="iconfont icon-delivery font-lg mr-sm" />
								<span class="font-md">交付</span>
							</div>
						</template>
					</el-menu-item>
					<el-menu-item index="space">
						<template slot="title">
							<div class="flex-center">
								<i role="button" class="iconfont icon-space font-lg mr-sm" />
								<span class="font-md">空间</span>
							</div>
						</template>
					</el-menu-item>
				</el-menu>
			</div>
			<div class="ft flex align-items-center">
				<div class="flex align-items-center mr" role="button" @click="show_pro_member = true">
					<div class="hd">
						<f-user-avatar :user="{avatar:project.principal_avatar,username:project.principal_username}" :preview="false" size="mini" role="button" />
						<!-- <img v-if="project && project.principal" :src="project.principal_avatar" alt="" class="image mini circle" />
						<img v-else src="@/assets/default-avatar.png" class="image mini circle" /> -->
					</div>
					<span class="bd pl-sm">共 {{ $store.state.middleStore.TeamMember.length }} 人</span>
				</div>
				<CommonMore :show="true" class="font-md" :list="commonConfig(project)" @click.native.stop="setActiveStyleId(project.projectid)" @change="handleMoreChange(project, $event)" />
			</div>
		</div>

		<!-- 内容 -->
		<div class="pm-detail-container">
			<ProjectTask v-if="activeTab == 'task'" :projectid="activeProjectid" />
			<ProjectDeliver v-if="activeTab == 'deliver'" :projectid="activeProjectid" />
			<ProjectSpace v-if="activeTab == 'space'" />
		</div>
		<project-member-draw v-if="show_pro_member" :show.sync="show_pro_member" />

		<!-- 新建/编辑项目弹窗 -->
		<PmEdit v-if="editShow" :show.sync="editShow" :projectid="projectid" :way="editWay" @submit="handleEditProject" />
		<!-- 设置分组弹窗 -->
		<PmGroup v-if="groupShow" :show.sync="groupShow" :list="groupList" :selected="activeProject.groupids" @change="setProjectToGroup" />
		<!-- 复制项目弹窗 -->
		<PmCopy v-if="copyShow" :show.sync="copyShow" @change="handleCopyProject" />
		<!-- 归档复制项目弹窗 -->
		<PmArchive v-if="archiveShow" :show.sync="archiveShow" :title="activeProject.project_title" @change="handleArchiveProject" />
		<!-- 删除项目弹窗 -->
		<PmRecycle v-if="recycleShow" :show.sync="recycleShow" :title="activeProject.project_title" @change="handleRecycleProject" />
		<!-- 彻底删除项目弹窗 -->
		<PmRemove v-if="removeShow" :show.sync="removeShow" :title="activeProject.project_title" @change="handleRemoveProject" />
	</div>
</template>

<script>
import { getProjectDetailApi } from '@/api/pm/projectApi'
import { starProjectApi } from '@/api/pm/projectApi'
import { getGroupListApi } from '@/api/pm/groupApi'
export default {
	components: {
		CommonMore: () => import('./components/common/CommonMore'),
		ProjectTask: () => import('./components/project/ProjectTask'),
		ProjectDeliver: () => import('./components/project/ProjectDeliver'),
		ProjectSpace: () => import('./components/project/ProjectSpace'),
		ProjectMemberDraw: () => import('./components/member/ProjectMemberDraw'),

		PmEdit: () => import('./components/pm/PmEdit'),
		PmGroup: () => import('./components/pm/PmGroup'),
		PmCopy: () => import('./components/pm/PmCopy'),
		PmArchive: () => import('./components/pm/PmArchive'),
		PmRecycle: () => import('./components/pm/PmRecycle'),
		PmRemove: () => import('./components/pm/PmRemove')
	},

	data () {
		return {
			activeTab: 'task',
			activeProjectid: null,
			show_pro_member: false,

			groupShow: false,
			copyShow: false,
			archiveShow: false,
			recycleShow: false,
			removeShow: false,
			editMenuShow: false,

			editShow: false,
			editWay: 'add', // add || edit
			projectid: '', // 当前表单内容
			groupList: [],//分组列表
			project: {},
			recentList: []
		}
	},

	computed: {
		commonConfig () {
			// commonMore组件配置处理
			return function (row) {
				let config = [
					{
						name: '编辑',
						command: 'edit'
					},
					{
						name: '设为星标',
						command: 'star'
					},
					{
						name: '移动到',
						command: 'move'
					},
					// {
					// 	name: '复制到',
					// 	command: 'copy'
					// },
					{
						name: '归档',
						command: 'archive'
					},
					{
						name: '删除',
						command: 'delete',
						type: 'danger'
					}
				]
				config.forEach(item => {
					if (row.star && item.command == 'star') {
						item.name = '取消星标'
					}
				})
				return config
			}
		}
	},

	watch: {
		$route: {
			handler (nval, oval) {
				if (nval.query.id != oval.query.id || nval.query.tab != oval.query.tab) {
					this.activeProjectid = nval.query.id
					this.fetchData()
					this.fetchRecentList()
				}
			},
			deep: true
		}
	},

	created () {
		this.activeProjectid = this.$route.query.id
		// if (sessionStorage.getItem('__SPACE__')) {
		// 	this.activeTab = sessionStorage.getItem('__SPACE__')
		// } else {
		this.activeTab = this.$route.query.tab
		// }
		this.$store.dispatch('setTeamMember', { projectid: this.activeProjectid })
		this.fetchData()
		this.fetchRecentList()
		this.fetchGroupData()
	},
	beforeDestroy () {
		this.$store.dispatch('clearTeam')
		sessionStorage.setItem('__SPACE__', null)
	},

	methods: {
		fetchData () {
			getProjectDetailApi({ projectid: this.activeProjectid }).then(res => {
				if (!res.errno) {
					this.project = res.data
				} else {
					this.$message.error(res.message)
				}
			})
		},

		fetchRecentList () {
			//TODO 最近访问清单
			// getRecentProjectApi().then(res => {
			// 	if (!res.errno) {
			// 		this.recentList = res.data
			// 	} else {
			// 		this.$message.error(res.message)
			// 	}
			// })
		},

		fetchGroupData () {
			getGroupListApi().then(res => {
				if (!res.errno) {
					this.groupList = res.data.list.filter(v => v.groupid)
				} else {
					this.$message.error(res.message)
				}
			})
		},

		// 最近项目下拉跳转
		handleCommandChange (e) {
			this.$router.push('/pm/detail?id=' + e + '&tab=' + this.activeTab)
		},

		// 取消星标
		starProject () {
			let params = {
				projectid: this.project.projectid,
				act: this.project.star ? 0 : 1
			}
			starProjectApi(params).then(res => {
				if (!res.errno) {
					this.fetchData()
					this.project.star ? this.$message.success('取消星标成功！') : this.$message.success('星标操作成功！')
				} else {
					this.$message.error(res.message)
				}
			})
		},

		toPm () {
			this.$router.push('/pm')
		},

		switchTab (e) {
			sessionStorage.setItem('__SPACE__', e)
			this.activeTab = e
		},

		/** 表格视图中【更多】全局组件回调处理 */
		handleMoreChange (row, e) {
			if (e == 'edit') {
				this.editProject(row)
			} else if (e == 'star') {
				this.starProject(row)
			} else if (e == 'move') {
				this.moveProject(row)
			} else if (e == 'copy') {
				this.copyProject(row)
			} else if (e == 'archive') {
				this.archiveProject(row)
			} else if (e == 'delete') {
				this.delProject(row)
			} else if (e == 'remove') {
				this.removeProject(row)
			}
		},

		moveProject (row) {
			this.activeProject = row
			this.groupShow = true
		},
		copyProject (row) {
			this.copyShow = true
		},
		archiveProject (row) {
			this.activeProject = row
			this.archiveShow = true
		},
		delProject (row) {
			if (row.is_delete) {
				// 在回收站中
				this.activeProject = row
				this.$confirm(`恢复项目后，项目即可正常使用。确定恢复？`, '恢复项目', {
					closeOnClickModal: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
					.then(() => {
						this.handleRecycleProject()
					})
					.catch(() => { })
			} else {
				// 不在回收站中
				this.activeProject = row
				this.recycleShow = true
			}
		},
		removeProject (row) {
			this.activeProject = row
			this.removeShow = true
		},

		/** 新建、编辑项目处理 */
		handleAddProjectShow () {
			this.editWay = 'add'
			this.projectid = null
			this.editShow = true
		},
		editProject (row) {
			this.projectid = row.projectid
			this.editWay = 'edit'
			this.editShow = true
		},
		handleEditProject (form) {
			let params = Object.assign({}, form, this.activeParam)
			if (form.projectid) {
				editProjectApi(params).then(res => {
					if (!res.errno) {
						this.fetchData()
						this.$message.success('编辑项目成功！')
					} else {
						this.$message.error(res.message)
					}
				})
			} else {
				createProjectApi(params).then(res => {
					if (!res.errno) {
						this.fetchData()
						this.$message.success('新建项目成功！')
					} else {
						this.$message.error(res.message)
					}
				})
			}



		},

		/** 复制项目处理 */
		handleCopyProject (e) {
			// console.log(e)
		},

		/** 归档项目处理 */
		handleArchiveProject () {
			let params = {
				projectid: this.activeProject.projectid,
				act: this.activeProject.archived ? 0 : 1
			}
			archiveProjectApi(params).then(res => {
				if (!res.errno) {
					this.fetchData(true)
					this.activeProject.archived ? this.$message.success('项目已恢复成功！') : this.$message.success('项目归档成功！')
				} else {
					this.$message.error(res.message)
				}
			})
		},
		recoverProject (item) {
			this.activeProject = item
			this.$confirm(`恢复项目后，项目即可正常使用。确定恢复？`, '恢复项目', {
				closeOnClickModal: false,
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			})
				.then(() => {
					this.handleArchiveProject()
				})
				.catch(() => { })
		},

		/** 删除项目处理（移至回收站） */
		handleRecycleProject () {
			let params = {
				projectid: this.activeProject.projectid,
				act: this.activeProject.is_delete ? 0 : 1
			}
			recycleProjectApi(params).then(res => {
				if (!res.errno) {
					this.fetchData(true)
					this.activeProject.is_delete ? this.$message.success('项目已恢复成功！') : this.$message.success('项目已移至回收站！')
				} else {
					this.$message.error(res.message)
				}
			})
		},
	}
}
</script>

<style lang="scss">
$--pm-detail-border-color: #e7e7e7;
$--pm-detail-hover-color: #f5f7f9;
$--pm-detail-active-color: #07c160;
$--pm-detail-container-bg: #f0f3f5;
$--pm-detail-add-btn-color: #8c939f;
.pm-detail {
	.pm-detail-nav {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		height: 60px;
		padding: 0 20px;
		background-color: #fff;
		.nav-btns {
			display: flex;
			border-radius: 4px;
			font-size: 26px;
			overflow: hidden;
			background-color: #fff;
			.btn {
				width: 40px;
				height: 40px;
				background-color: $--pm-detail-container-bg;
				&:hover {
					color: $--pm-detail-active-color;
					background-color: $--pm-detail-hover-color;
				}
			}
		}
		.el-menu--horizontal > .el-menu-item.is-active {
			background-color: $--pm-detail-container-bg;
		}
		.el-menu--horizontal.el-menu {
			border-bottom-color: #fff;
			.el-menu-item {
				background-color: #fff;
				&:hover {
					background-color: $--pm-detail-hover-color;
				}
			}
		}
	}
	.pm-detail-container {
		padding: 0 20px 20px;
		position: absolute;
		top: 60px;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: $--pm-detail-container-bg;

		.container-content {
			width: 100%;
			height: calc(100% - 15px);
		}
	}
}
</style>